import { create } from 'zustand';
import { Esercizio, esercizioVuoto } from '../interfaces/Esercizio';

type EsercizioStore = {
  esercizio: Esercizio;
  setEsercizio: (e: Esercizio) => void;
};

export const useEsercizioStore = create<EsercizioStore>(set => ({
  esercizio: esercizioVuoto,
  setEsercizio: (e: Esercizio) => set({ esercizio: e }),
}));

//export const useEserciziStore = create<any>(set => ({
//  esercizi: [],
//  setEsercizi: (e: any) => set({ esercizi: e }),
//}));